import React from 'react'
import { BuyerManagementStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  InputSearch,
  Paginate,
  Section,
  SelectBox,
  Table,
  Input,
} from '../../components'
import { isEmpty } from 'lodash'
import { ICONS } from '../../themes'
import { ROUTE_PATH, redirect, STRING } from '../../helpers'
import { buyermangeController } from '../../apiService'
import moment from 'moment'

export class BuyerManagementContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      options: [
        { value: '0', label: 'All' },
        { value: '1', label: 'Active' },
        { value: '2', label: 'Inactive' },
      ],
      isSortBy: [
        { name: 'tax_id', value: undefined },
        { name: 'company_name', value: undefined },
        { name: 'name', value: undefined },
      ],
      isHistoryModalOpen: false,
      data: [],
      BuyerListLoading: false,
      BuyerList: [],
      search: '',
      searchPage: 1,
      activePage: 1,
      dataSort: {
        role_id: 0,
        keyword: '',
        page: 1,
      },
    }
    this.optionsValue = 0
  }
  componentDidMount() {
    this._fetchBuyerList(0, '', 1)
  }

  _fetchBuyerList(status, keyword, page) {
    let data = {
      status: parseInt(status),
      keyword: keyword === '' ? '' : keyword,
      page: parseInt(page),
    }

    this.setState({ BuyerListLoading: true })
    return buyermangeController()
      .BuyerList(data)
      .then(res => this.setState({ BuyerList: res, BuyerListLoading: false }))
      .finally(() => this.setState({ BuyerListLoading: false }))
  }

  changePage = e => {
    this._fetchBuyerList(this.optionsValue, '', e)
    this.setState({ activePage: e })
  }

  toggleSort = evt => {
    var value
    this.state.isSortBy.find(column => {
      if (column.name === evt && column.value == undefined) {
        value = 'asc'
      } else if (column.name === evt && column.value == 'asc') {
        value = 'desc'
      } else if (column.name === evt && column.value == 'desc') {
        value = 'asc'
      }
      return value
    })
    this.setState(
      {
        dataSort: {
          ...this.state.dataSort,
          sort_by: value,
          sort_name: evt,
        },
      },
      () => {
        this.setState(prevState => ({
          ...prevState,
          isSortBy: prevState.isSortBy.map(column => ({
            ...column,
            value:
              column.name === evt
                ? column.value !== undefined
                  ? column.value === 'asc'
                    ? 'desc'
                    : 'asc'
                  : 'asc'
                : undefined,
          })),
        }))
        this.setState({ BuyerListLoading: true })
        return buyermangeController()
          .BuyerListSort(this.state.dataSort)
          .then(res =>
            this.setState({ BuyerList: res, BuyerListLoading: false })
          )
          .finally(() => this.setState({ BuyerListLoading: false }))
      }
    )
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => columns.name === evt)
      .map(column => column.value)[0]
  }

  toggleModal = () => {
    this.setState(prevState => ({
      isHistoryModalOpen: !prevState.isHistoryModalOpen,
    }))
  }

  _searchTagAdd = e => {
    const value = e.target.value.trim()
    this.setState({ search: value })
    if (e.keyCode == 13) {
      this._fetchBuyerList(this.optionsValue, value, 1)
    }
  }

  _filterStatus = e => {
    const DEFAULT_PAGE = 1
    this.optionsValue = e.value
    this._fetchBuyerList(e.value, this.state.search, 1)
    this.setState({ activePage: DEFAULT_PAGE })
  }

  renderStatus = status => {
    switch (status) {
      case 0:
        return { className: 'inactive-status', statusName: 'Inactive' }
      case 1:
        return { className: 'active-status', statusName: 'Active' }
      case 2:
        return { className: 'inactive-status', statusName: 'Inactive' }
      default:
        return { className: 'inactive-status', statusName: 'Inactive' }
    }
  }

  render() {
    const {
      options,
      isHistoryModalOpen,
      BuyerList,
      activePage,
      search,
    } = this.state
    let listBuyer = BuyerList == null ? [] : BuyerList.records || []
    return (
      <React.Fragment>
        <BuyerManagementStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_buyer_management"
                  src={ICONS['icon-user-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_buyer_management" className="title">
                  {STRING.BUYER_MANAGEMENT}
                </Section>

                <Section
                  id="page_breadcrumb_buyer_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>{STRING.BUYER_MANAGEMENT}</span>
                  </Button>
                </Section>
              </Section>
            </Section>

            <Section className="page-button">
              <Button
                className="page-button"
                onClick={() => {
                  this.props.history.push(ROUTE_PATH.BUYER_DETAIL_FORM.LINK)
                }}
              >
                {/* <Image src={ICONS['icon-add-circular.svg']} alt="add icon" /> */}
                Create Buyer
              </Button>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Section className="table-filter">
                <InputSearch
                  id="filter_search_input"
                  placeholder="Tax ID, Company Name"
                  onKeyDown={e => {
                    this._searchTagAdd(e)
                  }}
                  onChange={e => {
                    this._searchTagAdd(e)
                  }}
                />

                <SelectBox
                  onChange={e => {
                    this._filterStatus(e)
                  }}
                  id="active_status_filter"
                  className="table-filter"
                  options={options}
                  placeholder="All"
                  isSearchable={false}
                  isClearable={false}
                />
              </Section>

              <Section mt={'3rem'} className="table-responsive">
                <Table className="table-buyer">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR>
                      <Table.TH
                        className="w-150"
                        id="tax_id_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('tax_id')}
                        onClick={() => this.toggleSort('tax_id')}
                      >
                        TAX ID
                      </Table.TH>

                      <Table.TH
                        id="company_name_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('company_name')}
                        onClick={() => this.toggleSort('company_name')}
                      >
                        COMPANY NAME
                      </Table.TH>

                      <Table.TH
                        id="name_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('name')}
                        onClick={() => this.toggleSort('name')}
                      >
                        NAME
                      </Table.TH>

                      <Table.TH id="email_header">EMAIL</Table.TH>

                      <Table.TH className="w-150" id="phone_header">
                        PHONE
                      </Table.TH>

                      <Table.TH
                        className="text-center w-150"
                        id="status_header"
                      >
                        STATUS
                      </Table.TH>

                      <Table.TH id="create_date_header">CREATED DATE</Table.TH>

                      <Table.TH
                        className="actions text-center w-100"
                        id="actions_header"
                      >
                        ACTIONS
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>

                  {/* Content Row */}
                  <Table.TBODY>
                    {listBuyer !== undefined &&
                      listBuyer.map(e => (
                        <Table.TR key={e.id}>
                          <Table.TD className="w-150">{e.tax_id}</Table.TD>

                          <Table.TD title={e.company_name}>
                            {e.company_name}
                          </Table.TD>

                          <Table.TD title={e.full_name}>{e.full_name}</Table.TD>

                          <Table.TD title={e.email}>{e.email}</Table.TD>

                          <Table.TD className="w-150">{e.phone}</Table.TD>

                          <Table.TD className="text-center w-150">
                            <p
                              className={this.renderStatus(e.status).className}
                            >
                              {this.renderStatus(e.status).statusName}
                            </p>
                          </Table.TD>

                          <Table.TD>
                            {moment(e.update_date).format('lll')}
                          </Table.TD>

                          <Table.TD className="actions text-center w-100">
                            <Button
                              className="link"
                              onClick={() => {
                                // this.props.history.push(
                                //   ROUTE_PATH.BUYER_EDIT_FORM.LINK
                                // )
                                this.props.history.push(
                                  '/buyer-edit-form:' + e.id
                                )
                              }}
                            >
                              <Image
                                className="edit-icon"
                                src={ICONS['icon-edit.svg']}
                                alt="edit"
                              />
                            </Button>

                            {/* <Section className="link-edit-center">
                              <Button
                                className="link"
                                onClick={() => this.toggleModal()}
                              >
                                <Image
                                  className="history-icon"
                                  src={ICONS['icon-history.svg']}
                                  alt="history"
                                />
                              </Button>
                            </Section> */}
                          </Table.TD>
                        </Table.TR>
                      ))}
                  </Table.TBODY>
                  {isEmpty(listBuyer) && (
                    <Section className="no-result-found">
                      <Image
                        src={ICONS['icon-ssr.png']}
                        className="no-result"
                      />
                      <p>No result found</p>
                    </Section>
                  )}
                </Table>
              </Section>
            </Section>
            <Section className="content-footer">
              {isEmpty(listBuyer) ? (
                <Section className="showing-item">
                  Showing{' 0'}
                  to{' 0'}
                  &nbsp;of 0 entries
                </Section>
              ) : (
                <Section className="showing-item">
                  Showing{' '}
                  {isEmpty(listBuyer)
                    ? '0'
                    : BuyerList.offset === 0
                    ? '1'
                    : BuyerList.offset + 1}{' '}
                  to{' '}
                  {BuyerList.offset + BuyerList.limit > BuyerList.total_record
                    ? BuyerList.total_record
                    : BuyerList.offset + BuyerList.limit}
                  &nbsp;of {BuyerList.total_record} entries
                </Section>
              )}

              <Section className="paginate-wrapper">
                <Paginate
                  activePage={activePage}
                  itemsCountPerPage={BuyerList ? BuyerList.limit : 0}
                  totalItemsCount={BuyerList ? BuyerList.total_record : 0}
                  // totalItemsCount={30}
                  // pageRangeDisplayed={BuyerList.total_page}
                  // pageRangeDisplayed={3}
                  onChange={e => this.changePage(e)}
                />

                <Section className="moveto-wrapper">
                  <Input
                    className="paginate-moveto"
                    label="Page"
                    defaultValue={activePage}
                    isHorizontal
                    value={this.state.searchPag}
                    maxLength="4"
                    onChange={e =>
                      this.setState({ searchPage: parseInt(e.target.value) })
                    }
                  />

                  <Button
                    onClick={() => this.changePage(this.state.searchPage)}
                  >
                    go
                  </Button>
                </Section>
              </Section>
            </Section>
          </Section>
        </BuyerManagementStyled>

        <Modal
          id="history_id"
          className="buyer history theme-blue"
          isOpen={isHistoryModalOpen}
        >
          <Modal.Header>History</Modal.Header>

          <Modal.Body>
            <Section className="table-header-freeze-wrapper">
              <Table className="history header-freeze">
                <Table.TBODY>
                  <Table.TR>
                    <Table.TH className="activity">ACTIVITY</Table.TH>

                    <Table.TH className="action-by">ACTION BY</Table.TH>

                    <Table.TH className="create-date">CREATED DATE</Table.TH>
                  </Table.TR>
                </Table.TBODY>
              </Table>

              <Table className="history split-row-color">
                <Table.TBODY>
                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>
                </Table.TBODY>
              </Table>
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray close"
              onClick={() => this.toggleModal()}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}
